<div *ngIf="loading" class="row h-100">
  <div class="col-md-12 align-self-center">
      <wre-toolkit-loader></wre-toolkit-loader>
  </div>
</div>

<ng-container >
  <div *ngIf="errorMessageInfo" class="row text-center">
    <div class="col">
      <span class="wre-form-error">
        {{ errorMessageInfo }}
      </span>
    </div>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md-12">
          <div class="summary-bar border-bottom">
              <label class="form-control-label mb-0 me-2">
                  Field Name:
              </label>
              <span class="summary-detail">
                  <span>
                      <strong>{{fieldName}}</strong>
                  </span>
              </span>
          </div>
      </div>
    </div>

    <div class="details-cont">
    <ul ngbNav #nav="ngbNav" activeId="History" class="nav-tabs">
      <li ngbNavItem="History">
        <a ngbNavLink>History</a>
        <ng-template ngbNavContent>
          <div class="row">
            <div class="col">
              <div class="wre-tab-container" *ngIf="fieldAuditData">
                 <wre-field-history [fieldId]="fieldId" [AuditData]="fieldAuditData"></wre-field-history>
              </div>
            </div>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </div>
  </ng-container>
</ng-container>

